// Design tokens for GreenOne Dashboard V2 — a narrative "one path, not tiles" layout
// built on Swisscom SDX (sdx-* web components) colors and conventions.

// SDX-fixed categorical tokens: sdx-pie-chart only accepts these three color keywords
// for Scope 1/2/3 — every other custom mark (recharts, ticks, dots) that needs to
// match a scope reuses the same hex so the whole page reads as one system.
export const SCOPE_COLOR_KEY = { "Scope 1": "iris", "Scope 2": "azure", "Scope 3": "turquoise" };
export const IRIS = "#5944C6";
export const AZURE = "#1781e3";
export const TURQUOISE = "#0EABA9";
export const SCOPE_HEX = { "Scope 1": IRIS, "Scope 2": AZURE, "Scope 3": TURQUOISE };

export const BRAND = "#004A53";
export const PRIMARY = "#005654";
export const INTERACTION = "#026F6D";
export const ACCENT = INTERACTION;

export const BLUE = PRIMARY;

export const TEXT = "#0f172a";
export const MUTED = "#6b7280";
export const MUTED_2 = "#51606d";
export const SOFT_BORDER = "#ddd";

// Status palette — reserved for state, never reused as brand/interactions.
export const GOOD = "#15803d";
export const WARNING = "#d97706";
export const CRITICAL = "#b91c1c";

// Same single card surface as the classic dashboard (Dashboard.js cardStyle):
// light off-white fill, thin grey border, 12px radius, used everywhere.
export const SURFACE = "#F8FAFB";
export const SURFACE_TINT = "#F8FAFB";

export const bandStyle = {
  border: `1px solid ${SOFT_BORDER}`,
  borderRadius: "12px",
  padding: "1.5rem",
  backgroundColor: SURFACE,
  minWidth: 0,
  boxSizing: "border-box"
};

export const tintedBandStyle = {
  ...bandStyle
};

export const cardStyle = {
  border: `1px solid ${SOFT_BORDER}`,
  borderRadius: "12px",
  padding: "1rem",
  backgroundColor: SURFACE,
  minWidth: 0,
  boxSizing: "border-box"
};

export const sectionTitleStyle = {
  margin: 0,
  color: TEXT,
  fontSize: "1.08rem",
  lineHeight: 1.25,
  fontWeight: 700
};

export const sectionMetaStyle = {
  margin: "0.25rem 0 0",
  color: MUTED,
  fontSize: "0.85rem",
  lineHeight: 1.45
};

export function twoColumnGridStyle(isTablet, ratio = "minmax(0, 1.1fr) minmax(320px, 0.9fr)") {
  return {
    display: "grid",
    gridTemplateColumns: isTablet ? "1fr" : ratio,
    gap: "0.9rem"
  };
}

export const pill = {
  display: "inline-block",
  borderRadius: 4,
  padding: "2px 7px",
  background: "#f1f4f8",
  color: MUTED_2,
  fontSize: 11,
  fontWeight: 650
};

export function formatChange(val) {
  if (val === null || val === undefined || Number.isNaN(val)) return null;
  const sign = val > 0 ? "↑" : "↓";
  const color = val > 0 ? CRITICAL : GOOD;
  return { text: `${sign} ${Math.abs(val).toFixed(1)}%`, color };
}

export function formatNumber(value, digits = 1) {
  if (value === null || value === undefined || Number.isNaN(value)) return "–";
  return Number(value).toLocaleString("de-CH", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  });
}

export function formatInteger(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "–";
  return Math.round(Number(value)).toLocaleString("de-CH");
}